
import { defineComponent } from "vue";
import { Container } from "@/components/bosons";
import { Header, Presentation, Skills } from "@/components/organisms";

export default defineComponent({
  components: { Container, Header, Presentation, Skills }
});
